"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityRegistry__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "numOfAdmins",
                type: "uint256",
            },
        ],
        name: "AddAdmins",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "displayId",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "logoUrl",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "discordId",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "discordServerName",
                type: "string",
            },
        ],
        name: "ModifyCommunityMetadata",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "displayId",
                type: "string",
            },
        ],
        name: "RegisteredCommunity",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "numOfAdmins",
                type: "uint256",
            },
        ],
        name: "RemoveAdmins",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                internalType: "address[]",
                name: "admins",
                type: "address[]",
            },
        ],
        name: "addCommunityAdmins",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "communityIdToAdminOneIndexIndices",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "communityIdToAdmins",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        name: "communityIdToMetadata",
        outputs: [
            {
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "logoUrl",
                type: "string",
            },
            {
                internalType: "string",
                name: "discordId",
                type: "string",
            },
            {
                internalType: "string",
                name: "discordServerName",
                type: "string",
            },
            {
                internalType: "string",
                name: "displayId",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "s1",
                type: "string",
            },
            {
                internalType: "string",
                name: "s2",
                type: "string",
            },
        ],
        name: "compareStringsbyBytes",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                internalType: "string",
                name: "displayId",
                type: "string",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "logoUrl",
                type: "string",
            },
            {
                internalType: "string",
                name: "discordId",
                type: "string",
            },
            {
                internalType: "string",
                name: "discordServerName",
                type: "string",
            },
            {
                internalType: "address[]",
                name: "admins",
                type: "address[]",
            },
        ],
        name: "createCommunityAndAddInitialAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
        ],
        name: "doesCommunityExist",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                internalType: "string",
                name: "displayId",
                type: "string",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "logoUrl",
                type: "string",
            },
            {
                internalType: "string",
                name: "discordId",
                type: "string",
            },
            {
                internalType: "string",
                name: "discordServerName",
                type: "string",
            },
        ],
        name: "modifyCommunityMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "uniqId",
                type: "string",
            },
            {
                internalType: "address[]",
                name: "admins",
                type: "address[]",
            },
        ],
        name: "removeCommunityAdmins",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class CommunityRegistry__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.CommunityRegistry__factory = CommunityRegistry__factory;
CommunityRegistry__factory.bytecode = _bytecode;
CommunityRegistry__factory.abi = _abi;
